var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1jgyrvrdsa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.667 1.667H2.5a.833.833 0 0 0-.833.833v4.167a.833.833 0 0 0 1.666 0V3.333h3.334a.833.833 0 1 0 0-1.666zm0 15H3.333v-3.334a.833.833 0 1 0-1.666 0V17.5a.833.833 0 0 0 .833.833h4.167a.833.833 0 1 0 0-1.666zm10.833-15h-4.167a.833.833 0 1 0 0 1.666h3.334v3.334a.833.833 0 1 0 1.666 0V2.5a.833.833 0 0 0-.833-.833z",
    fill: "#174DC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.306 12.703a.396.396 0 0 0-.537-.581 3.074 3.074 0 0 1-2.091.817c-.778 0-1.521-.29-2.092-.817a.396.396 0 0 0-.537.58 3.863 3.863 0 0 0 2.629 1.028c.977 0 1.91-.365 2.628-1.027M10.469 10.083V7.271a.396.396 0 0 0-.791 0v2.812a.22.22 0 0 1-.22.22h-.322a.396.396 0 0 0 0 .79h.322c.557 0 1.01-.453 1.01-1.01M13.193 8.376V7.25a.374.374 0 0 0-.747 0v1.127a.374.374 0 1 0 .747 0M6.624 8.75a.374.374 0 0 1-.374-.374V7.25a.374.374 0 0 1 .747 0v1.127a.374.374 0 0 1-.373.374",
    fill: "#174DC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.87 11.892a.708.708 0 0 1 .96 1.04 4.175 4.175 0 0 1-2.84 1.11 4.175 4.175 0 0 1-2.84-1.11.708.708 0 0 1 .96-1.04c.514.474 1.18.735 1.88.735s1.367-.261 1.88-.735zm.424.46c-.629.58-1.447.9-2.304.9-.856 0-1.675-.32-2.304-.9m4.608 0a.083.083 0 0 1 .112.121 3.55 3.55 0 0 1-2.416.945 3.55 3.55 0 0 1-2.416-.945.083.083 0 0 1-.005-.117m0 0a.083.083 0 0 1 .117-.005zM9.678 7.27a.708.708 0 1 1 1.416 0v2.813c0 .73-.594 1.323-1.323 1.323h-.323a.708.708 0 1 1 0-1.416h.23V7.27zm.708-.082a.083.083 0 0 0-.083.083v2.812a.532.532 0 0 1-.532.532h-.323a.083.083 0 0 0 0 .166h.323a.7.7 0 0 0 .698-.698V7.271a.083.083 0 0 0-.083-.083zM12.446 7.249a.686.686 0 1 1 1.372 0v1.127a.686.686 0 0 1-1.372 0V7.25zm.686-.061a.061.061 0 0 0-.06.06v1.128a.061.061 0 1 0 .121 0V7.25a.061.061 0 0 0-.06-.061zM6.936 7.188a.061.061 0 0 0-.061.06v1.128a.061.061 0 0 0 .122 0V7.25a.061.061 0 0 0-.061-.061zm-.686.06a.686.686 0 1 1 1.372 0v1.128a.686.686 0 1 1-1.372 0V7.25z",
    fill: "#174DC4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#aaqax8uieb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5z",
    fill: "#24E4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M14.232 16.875a.45.45 0 0 1-.321-.134l-1.28-1.29a.46.46 0 0 1 .322-.78c.12 0 .236.048.322.133l.957.965 2.494-2.512a.453.453 0 0 1 .774.325.46.46 0 0 1-.131.323l-2.815 2.836a.45.45 0 0 1-.322.134z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1jgyrvrdsa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "aaqax8uieb",
    x: 7.25,
    y: 7.25,
    width: 15.5,
    height: 15.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.141176 0 0 0 0 0.894118 0 0 0 0 0.847059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationActive);
export default __webpack_public_path__ + "static/media/verification_active.dc71e89a41472b5bdeb0be88dde05006.svg";
export { ForwardRef as ReactComponent };